import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

const TEXTS = {
  fromTo: {
    default: 'checkout:accessFromTo',
    legal: 'organizations:memberships.checkout.paymentAccessDisclaimerFromTo'
  },
  from: {
    default: 'checkout:accessFrom',
    legal: 'organizations:memberships.checkout.paymentAccessDisclaimerFrom'
  },
  until: {
    default: 'checkout:accessUntil',
    legal: 'organizations:memberships.checkout.paymentAccessDisclaimerUntil'
  },
  noTimeGate: {
    default: 'organizations:memberships.membershipsTiers.accessOngoing',
    legal: 'organizations:memberships.checkout.paymentAccessDisclaimerOngoing'
  }
};

const dateFormat: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
};

function useProductTimeGateText(
  product: {
    validFrom: string;
    validUntil: string;
  },
  legalText = false
) {
  const { t } = useTranslation(['checkout']);
  let timeGateText = null;

  if (product.validFrom && product.validUntil) {
    timeGateText = t(TEXTS.fromTo[legalText ? 'legal' : 'default'], {
      startDate: new Date(product.validFrom).toLocaleString(
        i18n.language,
        dateFormat
      ),
      endDate: new Date(product.validUntil).toLocaleString(
        i18n.language,
        dateFormat
      )
    });
  } else if (product.validFrom) {
    timeGateText = t(TEXTS.from[legalText ? 'legal' : 'default'], {
      startDate: new Date(product.validFrom).toLocaleString(
        i18n.language,
        dateFormat
      )
    });
  } else if (product.validUntil) {
    timeGateText = t(TEXTS.until[legalText ? 'legal' : 'default'], {
      endDate: new Date(product.validUntil).toLocaleString(
        i18n.language,
        dateFormat
      )
    });
  } else {
    timeGateText = t(TEXTS.noTimeGate[legalText ? 'legal' : 'default']);
  }

  return timeGateText;
}

export default useProductTimeGateText;
